import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';


@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

  contactUsForm;
  public contactUsMassage = false;
  public contactUsErrorMassage = false;
  title = 'Contact us';

  contactUsObj = {
    data: {
      form: 1
    },
  };

  // location params for AGM map
  lat = 33.715025;
  lng = -117.9897419;


  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder) {
  }



  ngOnInit() {
    const styling = {
      leftNib: {
        transform: 'skewX(34.6deg)'
      },
      rightNib: {
        transform: 'skewX(-34.6deg)'
      },
      infoWindow: {
        'padding': '10px',
        'line-height': '1.5',
        'font-size': '14px',
        'font-weight': 'bolder',
      }
    };

    this.fixInfoWindowStyling(styling);

    this.contactUsForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      comment: ['', Validators.required]
    });
  }

  fixInfoWindowStyling(styling) {
    setTimeout(function() {
      const nibselector = $('.gm-style-iw').prev('div').children('div');
      const closeBtn = $('.gm-style-iw').next();
      const borderTop = nibselector.eq(0);
      const nibs = nibselector.eq(2);

      closeBtn.css({display: 'none'});
      borderTop.css({'border-top': 'none'});
      nibs.children('div').eq(0).find('div').css(styling.leftNib);
      nibs.children('div').eq(1).find('div').css(styling.rightNib);
      $('.agm-info-window-content').css(styling.infoWindow);
    }, 1500);
  }

  onSubmit() {
    let baseAPI;

    const headers = new Headers({ 'Content-Type': 'application/json; charset=UTF-8' });

    baseAPI = 'https://api.rebodata.net/benutechApi.php?method=notify&';
    this.http.post(baseAPI +
      'email=' + this.contactUsForm.value.email + '&name='
      + this.contactUsForm.value.name + '&content=' + this.contactUsForm.value.comment, headers)
      .subscribe(
        data  => {
          // console.log(data);
          // this.contactUsMassage = true;
        }
      );
    this.contactUsMassage = true;
    this.contactUsForm.reset();
  }
}



// WEBPACK FOOTER //
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/src/app/pages/contact-us/contact-us.component.ts